import { takeLatest, takeEvery } from 'redux-saga/effects';
import _ from 'lodash';

import { getAccountPath } from '../../utils/firebase';
import { fetchSaga, removeSaga, saveSaga } from '../sagas/helper';
import { fetchPrintersRoutine, savePrinterRoutine, removePrinterRoutine } from '../routines';
import { post, put } from '../../utils/request';

function* watchFetchPrintersSaga() {
  yield takeEvery(fetchPrintersRoutine.TRIGGER, fetchSaga(fetchPrintersRoutine, () => getAccountPath('printers')));
}

function* watchSavePrinterSaga() {
  yield takeEvery(savePrinterRoutine.TRIGGER, saveSaga(savePrinterRoutine,
    (payload) => getAccountPath('printers', payload.values.get('id')),
    (payload) => payload.values.get('id') ? put : post,
    (payload) => _.pick(payload.values.toJS(), ['name','type','connection','ip'])));
}

function* watchRemovePrinterSaga() {
  yield takeLatest(removePrinterRoutine.TRIGGER, removeSaga(removePrinterRoutine, (printer) => getAccountPath(`/printers/${printer.id}`)));
}

export {
  watchFetchPrintersSaga,
  watchSavePrinterSaga,
  watchRemovePrinterSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/printers.js